export const CUSTOMER_SEGMENT_DATA = 'CUSTOMER_SEGMENT_DATA';

export const setCustomerData = (data) => ({
  type: CUSTOMER_SEGMENT_DATA,
  payload: data,
});
